import React, { useCallback } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { Link } from 'react-router-dom'

import s from './Dnav.module.scss'

// 导航配置数据
const NAV_CONFIG = {
  tempRh: [
    { to: '/temp-rh-monitor-3t/overview', icon: s.nav_goose, msgId: 'goose3t', className: s.sub, isNew: true },
    { to: '/temp-rh-monitor-3/overview', icon: s.nav_goose, msgId: 'goose3_duck3', className: s.sub, isNew: true },
    { to: '/temp-rh-monitor-pro-s/overview', icon: s.nav_lora, msgId: 'pheasant', className: s.sub },
    { to: '/multi-role-monitor/overview', icon: s.nav_frog, msgId: 'frogs', className: s.sub, values: { br: '' }, isNew: true },
    { to: '/wall-socket-thermometer/overview', icon: s.nav_gecko, msgId: 'gecko_name', className: s.sub },
    { to: '/lee-guitars-thermo-hygrometer/overview', icon: s.nav_magpie, msgId: 'magpie', className: s.sub, values: { br: '' } },
    { to: '/comparison-temp-rh-monitor', icon: s.nav_comparison, msgId: 'comparison', className: s.line_s, values: { br: '' } },
  ],
  clock: [
    { to: '/bluetooth-alarm-clock/overview', icon: s.nav_dove, msgId: 'dove', className: s.sub },
    { to: '/bluetooth-clock/overview', icon: s.nav_chicken, msgId: 'chicken', className: s.line_s },
  ],
  air: [
    { to: '/air-monitor-2/overview', icon: s.nav_snow2, msgId: 'sw2', className: s.sub },
    { to: '/air-monitor-lite/overview', icon: s.nav_dany, msgId: 'dany_name', className: s.sub },
    { to: '/co2-temp-rh-monitor/overview', icon: s.nav_lora, msgId: 'ph_co2_name_value', className: s.sub },
    { to: '/indoor-environment-monitor/overview', icon: s.nav_robb, msgId: 'robb', className: s.sub, values: { br: '' }, isNew: true },
    { to: '/comparison-air-monitor', icon: s.nav_comparison, msgId: 'comparison', className: s.line_s, values: { br: '' } },
  ],
  sensor: [
    { to: '/door-window-sensor/overview', icon: s.nav_hodor, msgId: 'hodor_name', className: s.sub, values: { br: '' } },
    { to: '/motion-light-sensor/overview', icon: s.nav_parrot, msgId: 'parrot_name', className: s.line_s, values: { br: '' } },
  ],
  gateway: [
    { to: '/bluetooth-gateway/overview', icon: s.nav_sparrow, msgId: 'sparrow', className: s.line_s },
  ],
  other: [
    { to: '/home-app', icon: s.nav_app, msgId: 'cg_app', className: '' },
    { to: '/contact', icon: s.nav_phone, msgId: 'contact_us', className: s.sub },
  ],
}

// 外部链接配置
const EXTERNAL_LINKS = [
  { href: 'https://qingpingiot.com/', icon: s.nav_iot, msgId: 'qing_ping_iot', className: s.line_s },
  { href: 'https://developer.qingping.co/', icon: s.nav_developer, msgId: 'developer', className: s.line_s },
  { href: 'https://cleargrass.tmall.com/', icon: s.nav_store, msgId: 'store', className: s.line_s },
]

// 导航项组件
const NavItem = ({ to, icon, msgId, values, className, isNew, onClick }) => (
  <li className={className}>
    <Link to={to} onClick={onClick}>
      <i className={icon} />
      {isNew ? (
        <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
          <FormattedMessage id={msgId} values={values} />
          <div className={s.new}>
            <FormattedMessage id="new_tag" />
          </div>
        </div>
      ) : (
        <FormattedMessage id={msgId} values={values} />
      )}
    </Link>
  </li>
)

// 外部链接项组件
const ExternalLinkItem = ({ href, icon, msgId, className }) => (
  <li className={className}>
    <a href={href} target="_blank" rel="noopener noreferrer">
      <i className={icon} />
      <FormattedMessage id={msgId} />
    </a>
  </li>
)

// 标题组件
const SectionTitle = ({ msgId }) => (
  <li className={s.title}>
    <span>
      <FormattedMessage id={msgId} />
    </span>
  </li>
)

const Dnav = ({ locale, path, clickCallback }) => {
  // 处理点击事件
  const handleClick = useCallback(() => {
    // 滚动到顶部
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    
    // 如果当前路径与目标路径相同，执行回调
    const currentPath = window.location.pathname
    if (path === currentPath && clickCallback) {
      clickCallback()
    }
  }, [path, clickCallback])

  // 渲染导航组
  const renderNavSection = (titleMsgId, items) => (
    <>
      <SectionTitle msgId={titleMsgId} />
      {items.map((item) => (
        <NavItem
          key={item.to}
          {...item}
          onClick={handleClick}
        />
      ))}
    </>
  )

  // 判断是否显示备案信息
  const shouldShowBeian = locale.indexOf('US') === -1 && locale.indexOf('TW') === -1

    return (
      <div className={s.nav}>
        <ul>
        {renderNavSection('temp_rh', NAV_CONFIG.tempRh)}
        {renderNavSection('clock', NAV_CONFIG.clock)}
        {renderNavSection('air_name', NAV_CONFIG.air)}
        {renderNavSection('sensor_name', NAV_CONFIG.sensor)}
        {renderNavSection('gateway', NAV_CONFIG.gateway)}
        
        {NAV_CONFIG.other.map((item) => (
          <NavItem
            key={item.to}
            {...item}
            onClick={handleClick}
          />
        ))}
        
        {EXTERNAL_LINKS.map((link) => (
          <ExternalLinkItem key={link.href} {...link} />
        ))}
      </ul>
      
        <div className={s.copy}>
          <span>
            <FormattedMessage id="company_name" values={{ br: '' }} />
          </span>
        {shouldShowBeian && (
            <span>
              <a
                href="https://beian.miit.gov.cn/"
                target="_blank"
                rel="noopener noreferrer"
              >
                粤ICP备19156805号-1
              </a>
            </span>
          )}
        </div>
      </div>
    )
}

const mapStateToProps = (state) => ({
  locale: state.language,
})

export default connect(mapStateToProps)(Dnav)
